import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unavailable",
  "use": "icon-unavailable-usage",
  "viewBox": "0 0 39 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 39 40\" id=\"icon-unavailable\"><path d=\"M19.5.5C8.748.5 0 9.248 0 20s8.748 19.5 19.5 19.5S39 30.752 39 20 30.252.5 19.5.5Zm0 3C28.629 3.5 36 10.871 36 20c0 4.09-1.482 7.81-3.938 10.688L9.047 7.203C11.889 4.877 15.527 3.5 19.5 3.5ZM6.937 9.313l23.016 23.484C27.111 35.123 23.473 36.5 19.5 36.5 10.371 36.5 3 29.129 3 20c0-4.09 1.482-7.81 3.938-10.688Z\" fill=\"#0284C7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol